// src/pages/home/types.tsx

export interface EstadoServicio {
  id: number;
  texto: string;
  color: string;
  permiso: string | undefined;
}

export const estadosServicio: EstadoServicio[] = [
  { id: 1, permiso: undefined, texto: 'Creado', color: '#EDF3F6' }, // Neutro
  { id: 7, permiso: undefined, texto: 'Creado accesorios', color: '#CFE7FA' }, // Azul cielo
  { id: 2, permiso: undefined, texto: 'Despachado', color: '#CBEFE1' }, // Menta
  { id: 3, permiso: undefined, texto: 'Finalizado', color: '#FBE6BC' }, // Ambar
  { id: 4, permiso: "Prm_Credito_Cambiar", texto: 'Servicio en crédito', color: '#DBE5EE' }, // Azul acero
  { id: 5, permiso: undefined, texto: 'Pendiente de factura', color: '#F7D8DE' }, // Rosa
  { id: 6, permiso: undefined, texto: 'Cancelado', color: '#E1E6E9' }, // Gris
];

export interface DetalleServicio {
  SrvD_Pr_Id: string;
  SrvD_Cantidad: number;
  SrvD_ValorUnitario: number;
  SrvD_Iva: number;
  SrvD_Total: number;
  SrvD_Detalle: string;
  instaladores: Instalador[];
}

export interface Instalador {
  SrvDI_In_Id: string;
  SrvDI_Valor: number;
}

export interface Servicio {
  Srv_Id?: string;
  Srv_Cl_Id: string;
  Srv_Us_Id: string;
  Srv_FechaServicio: string;
  Srv_VehiculoMarca: string;
  Srv_VehiculoReferencia: string;
  Srv_VehiculoPlacaOSerial: string;
  Srv_Direccion: string;
  Srv_EsDomicilio: string;
  Srv_Observaciones: string;
  Srv_Factura: string;
  Srv_Estado?: string;
  Srv_Total?: number;
  detalle: DetalleServicio[];
}
